import React, {Component,} from "react"
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import {Grid} from "@mui/material";
import '../../../css/EditDetailsPopup.css';
import TextField from "@mui/material/TextField";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, {} from '@mui/material/Select';

const style = {
    outline: 0,
    border: 'none',

};


class EditDetailsPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    render() {
        return (
            <div>
                <Modal
                    sx={{backgroundColor: 'rgb(63, 69, 83, 0.85)', overflow: 'scroll', outline: 'none'}}
                    open={this.props.show_modal}
                >
                    <Fade in={this.props.show_modal}>
                        <Box className='modal_container'>
                            <div className='modal_background'>

                                <p className='subscribe_options' style={{ marginBottom: '40px' }}>Edit Personal Info </p>
                                {/*<p className='select_description_text'>Select a subscription tier from the options*/}

                                <TextField
                                    size="small"
                                    hiddenLabel
                                    name="login_field_username"
                                    // Add current details in here
                                    placeholder="First Name"
                                    value={this.props.user_profile_info['name']}
                                    onChange={(event) => this.props.UpdatePersonalInfo(event, 'name')}
                                    fullWidth
                                    id="filled-basic1" variant="filled"
                                    // helperText="{Please use...}"
                                    InputProps={{
                                        style: { fontSize: '18px' },
                                        disableUnderline: true,
                                    }}
                                    sx={{ marginBottom: '20px', backgroundColor: '#ffffff', width: '40%', minWidth:
                                            '290px', border: '0px', borderRadius: '5px', paddingTop: '0px',
                                        display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
                                />

                                {/* <TextField
                                    size="small"
                                    hiddenLabel
                                    name="login_field_username"
                                    // Add current details in here
                                    placeholder="Middle Name(s)"
                                    value={this.props.user_profile_info['middle_names']}
                                    onChange={(event) =>
                                        this.props.UpdatePersonalInfo(event, 'middle_names')
                                    }
                                    fullWidth
                                    id="filled-basic1" variant="filled"
                                    // helperText="{Please use...}"
                                    InputProps={{
                                        style: { fontSize: '18px' },
                                        disableUnderline: true,
                                    }}
                                    sx={{ marginBottom: '20px', backgroundColor: '#ffffff', width: '40%', minWidth:
                                            '290px', border: '0px', borderRadius: '5px', paddingTop: '0px',
                                        display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
                                />

                                <TextField
                                    size="small"
                                    hiddenLabel
                                    name="login_field_username"
                                    // Add current details in here
                                    placeholder="Last Name"
                                    value={this.props.user_profile_info['last_name']}
                                    onChange={(event) => this.props.UpdatePersonalInfo(event, 'last_name')}
                                    fullWidth
                                    id="filled-basic1" variant="filled"
                                    // helperText="{Please use...}"
                                    InputProps={{
                                        style: { fontSize: '18px' },
                                        disableUnderline: true,
                                    }}
                                    sx={{ marginBottom: '20px', backgroundColor: '#ffffff', width: '40%', minWidth:
                                            '290px', border: '0px', borderRadius: '5px', paddingTop: '0px',
                                        display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
                                /> */}


                                <FormControl fullWidth hiddenLabel variant="filled"
                                             sx={{ marginBottom: '20px', backgroundColor: '#ffffff', width: '40%', minWidth:
                                                     '290px', border: '0px', borderRadius: '5px', paddingTop: '0px',
                                                 display: 'block', marginLeft: 'auto', marginRight: 'auto', textAlign: 'left' }}>
                                    <Select
                                        displayEmpty
                                        // hiddenLabel="true"
                                        disableUnderline
                                        // label={"none"}
                                        fullWidth
                                        inputProps={{ 'aria-label': 'Without label' }}
                                        placeholder={"Test"}
                                        labelId="demo-customized-select-label"
                                        id="demo-customized-select"
                                        value={this.props.user_profile_info['country']}
                                        onChange={(event) => this.props.UpdatePersonalInfo(event, 'country')}
                                    >
                                        <MenuItem disabled value="">
                                            Country
                                        </MenuItem>
                                        {/*<MenuItem value={"none selected"}>none selected</MenuItem>*/}
                                        {this.props.country_list.map(
                                            (country) => {
                                                return (
                                                    <MenuItem value={country} sx={{ textAlign: 'left' }}>
                                                        {country}
                                                    </MenuItem>
                                                )
                                            }
                                        )}
                                    </Select>
                                </FormControl>

                                <FormControl fullWidth hiddenLabel variant="filled"
                                             sx={{ marginBottom: '20px', backgroundColor: '#ffffff', width: '40%', minWidth:
                                                     '290px', border: '0px', borderRadius: '5px', paddingTop: '0px',
                                                 display: 'block', marginLeft: 'auto', marginRight: 'auto', textAlign: 'left' }}>
                                    <Select
                                        hiddenLabel="true"
                                        displayEmpty
                                        disableUnderline
                                        fullWidth
                                        abelId="demo-customized-select-label"
                                        id="demo-customized-select"
                                        value={this.props.user_profile_info['gender']}
                                        onChange={(event) => this.props.UpdatePersonalInfo(event, 'gender')}
                                    >
                                        <MenuItem disabled value="">
                                            Gender
                                        </MenuItem>
                                        <MenuItem value={"none selected"}>None selected</MenuItem>
                                        <MenuItem value={"female"}>Female</MenuItem>
                                        <MenuItem value={"male"}>Male</MenuItem>
                                        <MenuItem value={"other"}>Other</MenuItem>
                                        <MenuItem value={"prefer to not say"}>Prefer to not say</MenuItem>
                                    </Select>
                                </FormControl>


                                {/* Button Group */}
                                <div className='button_container'>
                                    <Grid>
                                        <Grid xs={12}>
                                            <Button
                                                fullWidth
                                                variant="contained"
                                                sx={{
                                                    width: 'auto', backgroundColor: '#DB4437', fontSize: '18px',
                                                    textTransform: 'uppercase', padding: '3px 50px 3px 50px',
                                                    boxShadow: 'none', marginBottom: '20px', fontWeight: '600',
                                                    ':hover': {
                                                        bgcolor: '#ff5546',
                                                        color: 'white',
                                                        boxShadow: 'none',
                                                    },
                                                }}
                                                type="submit" value="submit"
                                                onClick={(e) => this.props.SubmitPersonalInfo(e)}
                                            >Submit</Button>
                                        </Grid>

                                        <Grid xs={12}>
                                            <Button
                                                onClick={this.props.closeButton}
                                            >Cancel</Button>
                                        </Grid>
                                    </Grid>
                                </div>
                            </div>
                        </Box>
                    </Fade>
                </Modal>
            </div>
        )
    }
}

export default EditDetailsPopup;